<template>
  <v-dialog
    persistent
    @click:outside="falseButtonClicked()"
    @keydown.esc="falseButtonClicked()"
    v-model="internalShowDialog"
    min-width="500"
    max-width="1024"
    scrollable
  >
    <v-card>
      <div
        @drop.prevent="handleDrop"
        @dragover.prevent="() => true"
        @dragenter.prevent="() => true"
        @dragleave.prevent="() => true"
      >
        <v-card-title class="text-title" style="margin-bottom: 0px !important">
          {{ $t("translations.add_translation") }}
        </v-card-title>
        <v-card-text style="height: 74vh;overflow:scroll">

            <v-text-field
                :autocomplete="autocompleteValueLocal"
                v-model="translation_key"
                class="to-upper"
                :label="$t('translations.translation_key')"
                v-on:keydown.enter.prevent=""
                :outlined="is_boxes"
                :dense="is_boxes"
            ></v-text-field>
            <v-select
                :items="availableResources"
                item-value="id"
                item-text="text"
                :label="$t('translations.application_resource')"
                v-model="application_resource_id"
            ></v-select>
            <v-select
                :items="translations"
                item-value="id"
                item-text="text"
                :label="$t('translations.translation_parent')"
                v-model="parent_id"
            ></v-select>
            <v-row>
            <v-col
                cols="12"
                >
                <v-row v-for="(language, index) in company_languages" :key="index">
                    <v-col cols="12" sm="12" class="pb-0">
                    <h3>{{ $t("appLanguage." + language) }}</h3>
                    </v-col>
                    <v-col cols="12" sm="12">
                    <NoteEditor
                        :label="$t('scheduler.note')"
                        v-model="translationsForLanguages[language]"
                        :showLabel="false"
                        :rows="1"
                    />
                    </v-col>
                </v-row>
                </v-col>
            </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pr-2">
          <v-spacer></v-spacer>
          <v-btn color="grey lighten-2" @click="falseButtonClicked()">
            {{ $t("attachment.close") }}
            <v-icon dark right> mdi-close </v-icon>
          </v-btn>
          <v-btn
          color="success"
          @click="addTranslation()"
          :disabled="$store.state.isLoading || !translation_key"
        >
          {{ $t("vehicles.Save") }}
          <v-icon dark right> mdi-content-save </v-icon>
        </v-btn>
        </v-card-actions>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "@/plugins/axios";
import { API_BASE_URL } from "@/config";
import { validationMixin } from "vuelidate";
import { maxLength } from "vuelidate/lib/validators";
import NoteEditor from "@/components/NoteEditor.vue";

export default {
  name: "AttachmentDialog",
  refs: ["attachment"],
  components: {
    NoteEditor
  },
  mixins: [validationMixin],
  props: {
    showDialog: [Number, Boolean],
    company_languages: [Array, Object],
    translations: [Array]
  },
  validations: {
    translation_key: {
      maxLength: maxLength(200),
    },
  },
  data() {
    return {
      is_boxes: this.getCompanyPropertyFromLocalStorage("boxes_on_fields", 1),
      data: null,
      isLoading: false,
      autocompleteValueLocal: "off",
      internalShowDialog: this.showDialog,
      translationsForLanguages: {},
      translation_key: null,
      application_resource_id: null,
      parent_id: null
    };
  },
  mounted() {},
  methods: {
    resetForm() {
      this.translation_key = null;
    },
    fixTitle(title) {
      return title.replaceAll("_", " ").toUpperCase();
    },
    addTranslation() {
      this.$store.commit("setValidation", true); // enable validation
      if (this.$v.$invalid) {
        this.$toast.warning(this.$t("please_fill_form_correctly"));
        return false;
      } else {
        let data = {
            key: this.translation_key,
            application_resource_id: typeof this.application_resource_id == 'object' ? this.application_resource_id.id : this.application_resource_id,
            parent_id: typeof this.parent_id == 'object' ? this.parent_id.id : this.parent_id,
        };
        this.company_languages.forEach((element) => {
            data[element] = this.translationsForLanguages[element]
        })
        this.isLoading = true;
        axios
          .post(API_BASE_URL + "/translations", [data], {
            headers: {
              Authorization: "Bearer " + this.$store.state.AccessToken,
            },
          })
          .then(() => {
            // 
          })
          .catch(() => {
            this.$toast.error(
                    this.$t("stocks.something_went_wrong")
                );
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
      this.$store.commit("setValidation", false); // disable validation
    },
    falseButtonClicked() {
      this.$emit("update:showDialog", false);
      this.$emit("buttonClicked", false);
      this.internalShowDialog = false;
    },

  },
  watch: {
    showDialog: {
      handler: function (val) {
        this.internalShowDialog = val;
      },
    },
    translations: {
        handler: function (val) {
            val.forEach((element) => {
                element.text = this.fixTitle(element.key);
            })
        },
        immediate: true
    }
  },
};
</script>

<style scoped>
</style>
